import PlanboardMode from './PlanboardMode.js'
import PlanboardModeChooseDeal from '@/components/planboard/PlanboardModeChooseDeal.js'
import Planner from '@/components/planboard/Planner.js'
import _ from 'lodash'

export default class PlanboardModeNewBooking extends PlanboardMode {
  constructor(planboard) {
    super(planboard)
    this.planner = new Planner(this, this.planboard.$elm.find('#planboard-new-booking-selector'))
  }

  start() {
    this.planboard.$defaultButtons.hide()
    this.planboard.$newBookingButtons.show()
    this.planboard.$elm.find('.planboard-slot').removeClass('active')
    this.planboard.$newBookingSelector.addClass('active')
    var html = _.template(window.templates.newBooking)()
    this.planboard.$newBookingSelectorContent.html(html)
  }

  stop() {
    this.planboard.$packageSelector.removeClass('active')
    this.planboard.$newBookingSelector.removeClass('active')
  }

  slotClick($slot, e) {
    var self = this
    if (!this.waitingSlot) {
      //if there's no slot waiting, create a new one
      var $elParent = $(_.template(window.templates.packageTableRow)()).appendTo(
        $('.planboard__package-selector.active').find('.planboard-package-selector__products'),
      )
      this.planboard.setWrapperHeight()
      const $el = $(e.originalEvent.target)
      this.waitingSlot = function($slot) {
        if ($slot.attr('data-available') == 'false') {
          return false // Prevent selection of occupied slots
        }
        self.planboard.dirty = true
        // check of product group key, zo ja voeg $productkey, $productgroupkey, $dealid toe
        if ($elParent.attr('data-product-group-key')) {
          $elParent.find('input[type=hidden]').val(
            JSON.stringify({
              id: $slot.data('id'),
              productKey: $elParent.attr('data-product-key'),
              productGroupKey: $elParent.attr('data-product-group-key'),
              productGroupName: $elParent.attr('data-product-group-name'),
              productGroupProductKey: $elParent.attr('data-product-group-product-key'),
              productGroupProductQuantity: $elParent.attr('data-product-group-product-quantity'),
              dealId: $elParent.attr('data-deal'),
            }),
          )
        } else {
          $elParent.find('input[type=hidden]').val($slot.data('id'))
        }
        $elParent
          .attr('data-selected-slot', $slot.attr('data-id'))
          .removeClass('planboard-package-product--waiting')
          .find('.table__cell--slot-time')
          .text($slot.attr('data-start-time'))
          .end()
          .find('[data-planboard-action="changetimeslot"]')
          .text('Change timeslot')
        $el
          .parents('.planboard__package-selector')
          .find('[data-planboard-action="addtimeslot"], [data-toggle="modal"]')
          .prop('disabled', false)
        $elParent
          .siblings()
          .addBack()
          .find('[data-planboard-action]')
          .prop('disabled', false)
        const $activityRow = $slot.parents('.planboard__activity'),
          activityLabel = _.template(window.templates.packageTableRowActivityLabel)({
            name: $activityRow.attr('data-activity-name'),
            color: $activityRow.attr('data-activity-color'),
            initials: $activityRow.attr('data-activity-initials'),
            activity: $slot.attr('data-activity-key'),
            iteration: $elParent.index(),
            selectedSlot: $slot.attr('data-id'),
          })
        $elParent
          .attr('data-id', $elParent.index() + '-' + $slot.attr('data-activity-key')) // Manually set data-id in the case of a newly added slot
          .find('.table__cell--activity')
          .html(activityLabel)
        self.planboard.$elm.find('.planboard-slot.changing').removeClass('changing')
        self.planboard.syncSelectorWithPlanboard()
        self.planboard.checkIfPackageBookable()
        return true
      }
    }

    PlanboardMode.prototype.slotClick.call(this, ...arguments)
  }

  onChoosePackage() {
    PlanboardModeChooseDeal.prototype.onChoosePackage.apply(this, arguments)
  }
}
